import { render, staticRenderFns } from "./DeliveryRow.vue?vue&type=template&id=27ba98bf&scoped=true&"
import script from "./DeliveryRow.vue?vue&type=script&lang=ts&"
export * from "./DeliveryRow.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryRow.vue?vue&type=style&index=0&id=27ba98bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ba98bf",
  null
  
)

export default component.exports